/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProcessDto
 */
export interface UpdateProcessDto {
    /**
     * プロセス名
     * @type {string}
     * @memberof UpdateProcessDto
     */
    name?: string;
    /**
     * 説明
     * @type {string}
     * @memberof UpdateProcessDto
     */
    description?: string;
}

/**
 * Check if a given object implements the UpdateProcessDto interface.
 */
export function instanceOfUpdateProcessDto(value: object): value is UpdateProcessDto {
    return true;
}

export function UpdateProcessDtoFromJSON(json: any): UpdateProcessDto {
    return UpdateProcessDtoFromJSONTyped(json, false);
}

export function UpdateProcessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProcessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UpdateProcessDtoToJSON(json: any): UpdateProcessDto {
    return UpdateProcessDtoToJSONTyped(json, false);
}

export function UpdateProcessDtoToJSONTyped(value?: UpdateProcessDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

